/* eslint-disable */
// https://webpack.js.org/guides/public-path/#on-the-fly
__webpack_public_path__ = window.VYDIA_SETTINGS.WEBPACK_DEV_SERVER_URL_JS || window.VYDIA_SETTINGS.CDN_URL || window.VYDIA_SETTINGS.URL
